import { Compute } from 'cerebral'
import { state } from 'cerebral/tags'

export default Compute(state`media.uploading`, (uploads, get) => {
  let allFiles = {}

  if (uploads) {
    Object.keys(uploads).forEach(uuid => {
      const file = uploads[uuid]
      if (file.percentComplete < 100) {
        allFiles[uuid] = {
          ...file,
          path: `media.uploading.${uuid}`
        }
      }
    })
  }

  return Object.keys(allFiles).map(fileKey => {
    return allFiles[fileKey]
  })
})



// WEBPACK FOOTER //
// ./src/modules/Media/computed/filesUploading.js